import { fomaBulgarian } from "./fomaBulgarian";
import { fomaGreek } from "./fomaGreek";
import { fomaHittite } from "./fomaHittite";
import { fomaNorwegian } from "./fomaNorwegian";
import { fomaOldEnglish } from "./fomaOldEnglish";
import { fomaOssetic } from "./fomaOssetic";
import { fomaWelsh } from "./fomaWelsh";

export const fomaAll: Record<string, string> = {
  'System PIE Bulgarian': fomaBulgarian,
  'System PIE Greek': fomaGreek,
  'System PIE Hittite': fomaHittite,
  'System PIE Norwegian': fomaNorwegian,
  'System PIE Old English': fomaOldEnglish,
  'System PIE Ossetic': fomaOssetic,
  'System PIE Welsh': fomaWelsh,
}